import { ANALYTICS_TRANSPORT, AnalyticsApp, AnalyticsIntegration, AnalyticsProduct, AnalyticsService } from '@glomopay/analytics';

import { ANALYTICS_EVENT_SCHEMAS, ANALYTICS_TRAITS_SCHEMA } from '../schemas/analytics-events.schema';

import { isJourneyEntry, journeyId } from '@/lib/journey/journey-id';

export const analyticsService = new AnalyticsService({
  instanceName: 'glomo_investor_portal',
  enabled: import.meta.env.VITE_IS_ANALYTICS_ENABLED === 'true',
  transport: ANALYTICS_TRANSPORT.MIXPANEL,
  mixpanel: {
    token: import.meta.env.VITE_MIXPANEL_TOKEN,
    apiHost: import.meta.env.VITE_MIXPANEL_API_HOST,
  },
  taxonomy: { events: ANALYTICS_EVENT_SCHEMAS, traits: ANALYTICS_TRAITS_SCHEMA },
  recordCalls: import.meta.env.VITE_COVERAGE === 'true',
  context: {
    app: AnalyticsApp.INVESTOR_PORTAL,
    product: AnalyticsProduct.INVESTOR_PORTAL,
    environment: import.meta.env.MODE,
    journey_id: journeyId,
    integration: isJourneyEntry ? AnalyticsIntegration.WEB_DIRECT : undefined,
  },
});
